var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./DurationView.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7bf0784e\",\"hasScoped\":false}!../../../vue-loader/lib/selector?type=template&index=0!./DurationView.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/@sdgsystems/vue-common/components/DurationView.vue
// module id = 385
// module chunks = 1